import { render } from "./OuboForm.vue?vue&type=template&id=a591f2da&scoped=true"
import script from "./OuboForm.vue?vue&type=script&lang=js"
export * from "./OuboForm.vue?vue&type=script&lang=js"

import "./OuboForm.vue?vue&type=style&index=0&id=a591f2da&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a591f2da"]])

export default __exports__